module.exports = __webpack_public_path__ + "img/bg-2.9318d0ed.png";